export default {
  "customerLookup": {
    "title": "Find by team ID",
    "teamId": "Team ID",
    "placeholder": "Enter a team ID",
    "open": "View details",
    "cancel": "Cancel",
    "invalid": "Enter a valid team ID (1–9223372036854775807)",
    "loading": "Loading customer details…",
    "invalidTitle": "Invalid team ID",
    "invalidDescription": "Return to the customer list and check the team ID.",
    "emptyTitle": "Customer not found",
    "emptyDescription": "Return to the customer list and confirm the team ID.",
    "unavailableTitle": "Customer details are unavailable",
    "unavailableDescription": "Try again shortly. If your session has expired, sign in again.",
    "retry": "Retry"
  }
};
